import ConsultaBase from "../shared/ConsultaBase";
import { ezchiller2compct6ConsultaConfig } from "../config/ezchiller2compct6Consulta";

const CezChiller2CompCT6 = () => {
  return <ConsultaBase config={ezchiller2compct6ConsultaConfig} />;
};

export default CezChiller2CompCT6;